"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteBucketPolicyOutput = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=DeleteBucketPolicyOutput.js.map